// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  bar: "MarkerBar__bar",
  barLine: "MarkerBar__barLine",
  gutter: "MarkerBar__gutter",
  track: "MarkerBar__track",
  value: "MarkerBar__value",
  valueEnd: "MarkerBar__valueEnd",
};
